import React from 'react';
import Modal from '../../../../../components/Modal';
import Img from '../../../../../components/Img';

const ImgPreviewModal = (props) => {
  const { isOpen, closeModal, data } = props;
  const { url } = data;
  return (
    <Modal
      title="이미지 보기"
      onClose={() => closeModal()}
      isOpen={isOpen}
      width={630}
      height={630}
      isFooter={true}
      onOk={() => closeModal()}
    >
      <Img src={url} style={{ width: 600 }} />
    </Modal>
  );
};

export default ImgPreviewModal;
